import React from "react";
import { Link } from "react-router-dom";
import { Button } from "./ui/button";
import { Flag, Award } from "lucide-react";
import { AnimatedCountUp } from "./AnimatedNumber";

const HeroSection = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section
      id="hero"
      className="relative h-screen flex items-center"
      style={{
        backgroundImage: "url(/hero.webp)",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-[#1a0f08] via-[#1a0f08]/70 to-transparent"></div>

      {/* MII & MSME logos — top right, below fixed navbar, side by side */}
      <div className="absolute z-20 top-24 sm:top-28 right-4 sm:right-6 lg:right-12 flex flex-row flex-wrap items-center justify-end gap-3 pointer-events-none">
        <span className="inline-flex items-center justify-center rounded-md bg-white px-2 py-1.5 shadow-sm">
          <img
            src="/mii.png"
            alt="Make in India"
            className="h-8 sm:h-10 md:h-12 w-auto max-w-[120px] sm:max-w-[140px] object-contain"
          />
        </span>
        <span className="inline-flex items-center justify-center rounded-md bg-white px-2 py-1.5 shadow-sm">
          <img
            src="/msme.webp"
            alt="MSME"
            className="h-8 sm:h-10 md:h-12 w-auto max-w-[120px] sm:max-w-[140px] object-contain"
          />
        </span>
      </div>

      <div className="container mx-auto px-6 lg:px-12 relative z-10">
        <div className="max-w-2xl">
          <h1 className="text-5xl lg:text-6xl xl:text-7xl font-bold text-white mb-4 leading-tight">
            Coveyors, Ovens, Mixers &amp; Slicers
          </h1>

          {/* <h2 className="text-2xl lg:text-3xl text-[#d4a574] mb-6 font-normal">
            Rahul Engineering Works — Kanpur, India
          </h2> */}

          {/* <p className="text-base lg:text-lg text-white/80 mb-10 leading-relaxed">
            Manufacturer of industrial bakery machines in Kanpur since 1992 —
            rotary rack ovens, tunnel ovens, spiral mixers, bread slicers, rusk
            lines and complete bread, rusk &amp; biscuit plant equipment across
            India.
          </p> */}

          <div className="flex flex-wrap gap-4 mb-12">
            <Button
              onClick={() => scrollToSection("contact")}
              className="bg-[#c9923f] hover:bg-[#b8822e] text-white font-semibold px-8 py-6 text-base rounded transition-all"
            >
              Get Quote
            </Button>
            <Button
              asChild
              className="bg-transparent border-2 border-white/50 text-white hover:bg-white/10 font-semibold px-8 py-6 text-base rounded transition-all"
            >
              <Link to="/products">View Products</Link>
            </Button>
          </div>

          <div className="flex flex-wrap gap-6">
            <div className="flex items-center gap-2 bg-[#2a1810]/60 px-4 py-2 rounded">
              <Flag className="text-[#d4a574]" size={18} />
              <span className="text-white text-sm">Made in India</span>
            </div>
            <div className="flex items-center gap-2 bg-[#2a1810]/60 px-4 py-2 rounded">
              <Award className="text-[#d4a574]" size={18} />
              <span className="text-white text-sm">
                <AnimatedCountUp value={1000} suffix="+" /> Installations
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
